module.exports = __webpack_public_path__ + "static/thumb-outdoor-fc8c542aea6e00232a19dd929e2d419b.png";